import cn from "@/utils/cn"
import { ReactNode } from "react"
import { toast } from "sonner"

type ToastProps = {
  toastId: string | number
  variant?: "info" | "error"
  title?: ReactNode
  description: ReactNode
  action?: ReactNode
}

const Toast = ({
  toastId,
  variant = "info",
  title,
  description,
  action,
}: ToastProps) => (
  <div
    className={cn(
      "grid grid-cols-[min-content_1fr_min-content] gap-4 rounded-md border border-sky-500 bg-sky-400 p-4 text-white/90",
      {
        "border-red-600 bg-red-500": variant === "error",
      },
      {
        "border-sky-500 bg-sky-400": variant === "info",
      }
    )}
  >
    <span className="material-icons">
      {variant === "error" ? "error" : "info"}
    </span>
    <div className="grid gap-1">
      {title && <h1 className="font-semibold">{title}</h1>}
      {description && <p className="font-medium">{description}</p>}
    </div>
    <div className="flex flex-col items-end justify-between gap-4">
      <button
        className="flex cursor-pointer border-none bg-transparent"
        onClick={() => toast.dismiss(toastId)}
      >
        <span className="material-icons" style={{ fontSize: "20px" }}>
          close
        </span>
      </button>
      {action}
    </div>
  </div>
)

export default Toast
